import * as React from "react";

const OldDownload: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="15"
            viewBox="0 0 13 15"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="M6.27935402,10.8850274 C6.35584041,10.9597596 6.45880286,11 6.55882353,11 C6.65884419,11 6.76180664,10.9626339 6.83829304,10.8850274 L10.0007111,7.7951398 C10.1566257,7.64280115 10.1566257,7.39848445 10.0007111,7.24614581 C9.84479657,7.09380716 9.5947449,7.09380716 9.43883034,7.24614581 L6.95596441,9.67206689 L6.95596441,0.388032401 C6.95596441,0.172458845 6.77945735,0 6.55882353,0 C6.33818971,0 6.16168265,0.172458845 6.16168265,0.388032401 L6.16168265,9.67206689 L3.67881672,7.24614581 C3.52290216,7.09380716 3.27285049,7.09380716 3.11693593,7.24614581 C2.96102136,7.39848445 2.96102136,7.64280115 3.11693593,7.7951398 L6.27935402,10.8850274 Z M12.5556962,14 L0.444303797,14 C0.197468354,14 0,14.1699346 0,14.3823529 C0,14.5947712 0.197468354,14.7647059 0.444303797,14.7647059 L12.5556962,14.7647059 C12.8025316,14.7647059 13,14.5947712 13,14.3823529 C13,14.1699346 12.8025316,14 12.5556962,14 Z"></path>
        </svg>
    );
};

export default React.memo(OldDownload);
